import React from 'react';
export const CFIconCodeDownload = {
    alias: 'code-download',
    defaultTitle: 'Code Download',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'm21.78 11.373-4.829-6a1 1 0 0 0-1.559 1.254l4.317 5.362-4.477 5.37a1.003 1.003 0 0 0 .768 1.64.998.998 0 0 0 .768-.358l5-6a1 1 0 0 0 .011-1.268Zm-17.488.637L8.77 6.64a1.002 1.002 0 0 0-.128-1.409 1.003 1.003 0 0 0-1.41.128l-5 6a1 1 0 0 0-.01 1.267l4.828 6a1 1 0 1 0 1.558-1.254L4.292 12.01Zm10.014-.626a1 1 0 0 1 1.389 1.439l-3 2.897a1.003 1.003 0 0 1-1.402-.013l-3-3a1 1 0 0 1 1.414-1.414l1.292 1.292V8a1 1 0 1 1 2 0v4.644l1.306-1.26Z' }))),
};
